import { Component, Prop, Vue } from 'vue-property-decorator';
import draggable from "vuedraggable";
import { WidgetData } from "@/components/Dashboard/Widgets/types/Widget";
import { toCamel, toSnake } from "snake-camel";
import { WidgetGet, WidgetInstanceAllPut } from "@/components/Dashboard/Widgets/types/WidgetAPI";
import store from '@/assets/common/store/store';

@Component({
    components: {
        draggable
    }
})
export default class WidgetContents extends Vue {
    private contents: WidgetData[] = [];
    private displayOrder = 0

    @Prop()
    private widgetLimit!: number;

    @Prop({ default: false }) showWidgetContents!: boolean

    created(): void {
        this.getContents()
        this.$eventHub.$on('getContentsCount', () => {
            this.$eventHub.$emit('countContents', this.contents.length)
        })
    }

    refresh(): void {
        this.contents = [];
        this.displayOrder = 0
        this.getContents()
        this.$eventHub.$on('getContentsCount', () => {
            this.$eventHub.$emit('countContents', this.contents.length)
        })
    }

    private getContents() {
        this.$apiClient.doRequest('get', `/admin/widget_instances`).then((ret) => {
            for (const widgetContent of ret) {
                const content = toCamel(widgetContent) as WidgetData
                content.config = toCamel(JSON.parse(content.config))
                this.contents.push(content)
            }
        })
    }

    private openSettingModal(index: number) {
        this.displayOrder = index
        this.$emit('openModal', this.contents[index], true)
    }

    // DashboardSettingsから送られてきたデータで更新
    private updateContent(item: WidgetData, isUpdateContent: boolean) {
        if (isUpdateContent) {
            this.contents.splice(this.displayOrder, 1, item)
        } else {
            this.contents.push(item)
        }
        this.inputChanged();
    }

    private deleteContent(index: number) {
        if (confirm('このウィジェットを削除してよろしいですか？')) {
            this.inputChanged();
            this.contents.splice(index, 1)
        }
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            if (!window.confirm("変更内容を破棄します。よろしいですか。")) {
                return false
            }
            this.refresh();
            this.$store.dispatch('doUpdateIsInputChanged', false);
        }
    }

    private inputChanged() {
        if (store.getters.isInputChanged == false) {
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    private doUpdate() {
        if (!window.confirm("内容を上書きして保存します。よろしいですか。")) {
            return false
        }
        this.$apiClient.doRequest('get', `/admin/widgets`).then(ret => {
            const params: WidgetInstanceAllPut[] = [];
            for (let i = 0; i < this.contents.length; i++) {
                const content = this.contents[i] as WidgetData
                params.push({
                    widget_id: ret.find((masterWidget: WidgetGet) => content.component == masterWidget.component).id,
                    title: content.title,
                    config: JSON.stringify(toSnake(content.config))
                })
            }
            this.$apiClient.doRequest('put', `/admin/widget_instances`, params).then((ret) => {
                this.$toasted.success('変更を保存しました。')
                this.$store.dispatch('doUpdateIsInputChanged', false);
                this.$router.push('/dashboard')
            }).catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
        })
    }
}